import React, { PureComponent } from 'react';
import { Form, FormGroup, SubmitButton } from '../../../components/Forms/Forms';
import { Input, Textarea, Select } from '../../../components/Forms/fields/index';
import Balance from './Balance';
import OfferDetails from './OfferDetails';
import Auth from "../../../libs/Auth";

class OffersView extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeOfferModal: null,
    };
  }
  mappedOffer(offer) {
    return {
      offer_hash: offer.offer_hash,
      currency: offer.fiat_currency_code,
      payment_method: offer.payment_method_name,
      margin: offer.margin,
      range_min: offer.fiat_amount_range_min,
      range_max: offer.fiat_amount_range_max,
      payment_method_label: offer.payment_method_label,
      offer_terms: offer.offer_terms,
      require_verified_email: offer.require_verified_email,
      require_verified_phone: offer.require_verified_phone,
      require_min_past_trades: offer.require_min_past_trades,
      show_only_trusted_user: offer.show_only_trusted_user,
      predefined_amount: offer.predefined_amount,
      // can't find these properties on the offer
      // trade_details: offer.xxxx,
      // payment_method_group: offer.xxxx,
      // payment_window: offer.xxxx,
    }
  }
  render() {
    const {
      offers,
      offerGroups,
      deactivateOffer,
      activateOffer,
      turnOnOffers,
      turnOffOffers,
      onFormUpdate,
      submitForm,
      formState,
      groupedOffers,
    } = this.props;

    const canEditOfferGroup = Auth.isType(['admin', 'manager']);
    const enableCreateOfferGroup = canEditOfferGroup && formState.data && formState.data.offers && !!formState.data.offers.find(item=> item);
    return (
      <div className="offers-page page">
        <h2>Offers</h2>
        <Balance />
        <Form state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
          <div className="actions">
            <button className="button" type="submit" disabled={!enableCreateOfferGroup} title="create offer group"><i className="fi-plus size-18"></i></button>
            <button className="button success" type="button" onClick={turnOnOffers}><i className="fi-check size-18"></i> Activate All</button>
            <button className="button alert" type="button" onClick={turnOffOffers}><i className="fi-x size-18"></i> Deactivate All</button>
          </div>
          <div className="offer-groups">

            {offerGroups.map((offerGroup)=>(
              <div className="offer-group button-group" key={offerGroup._id}>
                <label onClick={()=>this.props.selectOfferGroup(offerGroup)}>{offerGroup.name}</label>
                <button onClick={()=>this.props.enableOfferGroup(offerGroup._id)} type="button" className="button success"><i className="fi-check"></i></button>
                <button onClick={()=>this.props.disableOfferGroup(offerGroup._id)} type="button" className="button alert"><i className="fi-x"></i></button>
                {canEditOfferGroup && (
                  <button onClick={()=>this.props.removeOfferGroup(offerGroup._id)} type="button" className="remove-button"><i className="fi-minus"></i></button>
                )}
              </div>
            ))}

          </div>
          {['buy', 'sell'].map((offerType, i)=>(
            <div key={i}>
              <h3>{offerType}</h3>
              <table>
                <thead>
                <tr>
                  {canEditOfferGroup && (
                    <th>
                      <input type="checkbox" onChange={(e)=>{
                        this.props.toggleCheckboxes(e.target.checked);
                      }}/>
                    </th>
                  )}
                  <th>Payment Type</th>
                  <th>Currency</th>
                  <th>Offer Type</th>
                  <th>Active</th>
                  <th>Margin</th>
                  <th>Range</th>
                  <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {groupedOffers[offerType].map((offer, i) => (
                  <tr key={offer.offer_hash}>
                    {canEditOfferGroup && (
                      <td><Input name={`offers[${i}]`} type='checkbox' defaultValue={false}/></td>
                    )}
                    <td><a href={`https://paxful.com/offer-manager/edit/${offer.offer_hash}`} target="_blank">{offer.payment_method_name}</a></td>
                    <td>{offer.fiat_currency_code}</td>
                    <td>{offer.offer_type}</td>
                    <td>
                      {offer.active ? (
                        <i className="fi-check size-18 active"></i>
                      ) : (
                        <i className="fi-x size-18 deactivated"></i>
                      )}
                    </td>
                    <td>{offer.margin}</td>
                    <td>{offer.fiat_amount_range_min} - {offer.fiat_amount_range_max}</td>
                    <td>
                      <div className="action-buttons">
                        {offer.active ? (
                          <button type="button" onClick={() => deactivateOffer(offer.offer_hash)}><i className="fi-x size-18"></i> deactivate</button>
                        ) : (
                          <button type="button" onClick={() => activateOffer(offer.offer_hash)}><i className="fi-check size-18"></i> activate</button>
                        )}
                        {(Auth.isType(['admin']) || offer.offer_type === 'sell') && (
                          <button
                            type="button"
                            onClick={() => {
                              this.setState({
                                activeOfferModal: offer.offer_hash,
                              });
                            }}
                          ><i className="fi-pencil size-18"></i> edit</button>
                        )}
                      </div>
                      {this.state.activeOfferModal === offer.offer_hash && (
                        <OfferDetails
                          offer={this.mappedOffer(offer)}
                          onClose={()=>{
                            this.setState({
                              activeOfferModal: null,
                            });
                          }}
                        />
                      )}
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            </div>
          ))}

        </Form>
      </div>
    )
  }
}

export default OffersView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/Offers.view.js